import { useMediaQuery } from '@mui/material';
import React from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'store';

interface RightAppSidebarContentProps {
  children: React.ReactNode;
  id: string;
}

const RightAppSidebarContent: React.FC<RightAppSidebarContentProps> = ({ children, id }) => {
  const activeId = useSelector((state) => state.dualSidebar.right.activeId);
  const initialMessage = useSelector((state) => state.dualSidebar.right.initialMessage);
  const downMidXl = useMediaQuery((theme) => theme.breakpoints.down('midxl'));

  // Force re-render when downMidXl changes
  React.useEffect(() => {
    // This effect ensures the component re-renders when downMidXl changes
  }, [downMidXl]);

  const sidebarWrapper = document.getElementById('right-sidebar-content-wrapper');
  
  console.log(`📋 RightAppSidebarContent [${id}]:`, {
    activeId,
    match: activeId === id,
    hasWrapper: !!sidebarWrapper,
    willRender: !!(sidebarWrapper && activeId === id)
  });

  // Clone children and pass initialMessage prop if available
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child) && initialMessage) {
      return React.cloneElement(child, { initialMessage } as any);
    }
    return child;
  });

  return sidebarWrapper && activeId === id ? createPortal(childrenWithProps, sidebarWrapper) : null;
};

export default RightAppSidebarContent; 